export default __webpack_public_path__ + "a40730ae70122698af79cf123f9d3add.png";